import { Link } from 'react-router-dom';
import { useLanguage } from '../../i18n/LanguageProvider';
import { useOrgContext } from '../org/OrgProvider';
import { useSidebarContext } from './SidebarProvider';

export const SidebarFooter = () => {
  const { messages } = useLanguage();
  const { org } = useOrgContext();
  const { expanded } = useSidebarContext();

  if (!expanded) return null;

  return (
    <div
      style={{
        padding: '12px 16px',
        borderTop: '1px solid #eef0f6',
      }}
    >
      {org && (
        <div style={{ marginBottom: 8 }}>
          <span
            style={{
              fontSize: 11,
              color: '#94a3b8',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
            }}
          >
            {org.name}
          </span>
        </div>
      )}
      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {[
          { to: '/faq', label: messages.footer.faq },
          { to: '/privacy', label: messages.footer.privacy },
          { to: '/terms', label: messages.footer.terms },
        ].map(l => (
          <Link
            key={l.to}
            to={l.to}
            style={{ fontSize: 11, color: '#94a3b8', textDecoration: 'none' }}
          >
            {l.label}
          </Link>
        ))}
      </div>
    </div>
  );
};
